import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LOCALE } from './const';
import TranslationEN from './translations/en.json';
import TranslationES from './translations/es.json';
import TranslationFR from './translations/fr.json';

// TODO:
// 1. Detect browser preferd lang with i18next-browser-languagedetector (?)
// 2. Add func that takes saved lang from storage/user data and passes it to lng on init()
// 3. Move tranclation files from FE to BE side on init(): { backend: { loadPath: `${appSrc}/locales/{{lng}}.json` }}
// 4. Resolve SSR with useSSR() hook (right after 3 step).

const resources = {
  en: {
    translation: TranslationEN,
  },
  es: {
    translation: TranslationES,
  },
  fr: {
    translation: TranslationFR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE, // lang that will be used in case detected lang is not defined
  interpolation: {
    escapeValue: false,
  },
  parseMissingKeyHandler: () => '',
});

export default i18n;
